// 主题色覆盖（运行时注入，确保覆盖所有 Element Plus 默认值）
const themeOverrides = document.createElement('style')
themeOverrides.textContent = `
:root {
  --el-color-primary: #2C60EA;
  --el-color-primary-rgb: 44, 96, 234;
  --el-color-primary-light-1: #4573ec;
  --el-color-primary-light-2: #5e86ee;
  --el-color-primary-light-3: #7899f0;
  --el-color-primary-light-4: #91adf2;
  --el-color-primary-light-5: #AAC0F4;
  --el-color-primary-light-6: #C4D4F7;
  --el-color-primary-light-7: #DDE7F9;
  --el-color-primary-light-8: #E9EFFB;
  --el-color-primary-light-9: #F5F8FD;
  --el-color-primary-dark-2: #234DBC;
  --el-color-success: #059669;
  --el-color-success-rgb: 5, 150, 105;
  --el-color-success-light-1: #23a17a;
  --el-color-success-light-2: #3fae8b;
  --el-color-success-light-3: #5cbb9c;
  --el-color-success-light-4: #78c9ad;
  --el-color-success-light-5: #95d6be;
  --el-color-success-light-6: #b1e3cf;
  --el-color-success-light-7: #cef1e0;
  --el-color-success-light-8: #daf6e9;
  --el-color-success-light-9: #edfbf4;
  --el-color-success-dark-2: #044b2a;
  --el-color-warning: #fbbf24;
  --el-color-warning-rgb: 251, 191, 36;
  --el-color-warning-light-1: #fcc43c;
  --el-color-warning-light-2: #fdca55;
  --el-color-warning-light-3: #fdd06e;
  --el-color-warning-light-4: #fdd687;
  --el-color-warning-light-5: #fddca0;
  --el-color-warning-light-6: #fee2b9;
  --el-color-warning-light-7: #fee8d2;
  --el-color-warning-light-8: #feeeeb;
  --el-color-warning-light-9: #fff7f3;
  --el-color-warning-dark-2: #a77d18;
  --el-color-danger: #f43f5e;
  --el-color-danger-rgb: 244, 63, 94;
  --el-color-danger-light-1: #f55a74;
  --el-color-danger-light-2: #f6748a;
  --el-color-danger-light-3: #f78f9f;
  --el-color-danger-light-4: #f8a9b5;
  --el-color-danger-light-5: #f9c4cb;
  --el-color-danger-light-6: #faded1;
  --el-color-danger-light-7: #fbe9e7;
  --el-color-danger-light-8: #fcf0ed;
  --el-color-danger-light-9: #fef7f7;
  --el-color-danger-dark-2: #a0283d;
  --el-color-error: #f43f5e;
  --el-color-error-rgb: 244, 63, 94;
  --el-color-error-light-1: #f55a74;
  --el-color-error-light-2: #f6748a;
  --el-color-error-light-3: #f78f9f;
  --el-color-error-light-4: #f8a9b5;
  --el-color-error-light-5: #f9c4cb;
  --el-color-error-light-6: #faded1;
  --el-color-error-light-7: #fbe9e7;
  --el-color-error-light-8: #fcf0ed;
  --el-color-error-light-9: #fef7f7;
  --el-color-error-dark-2: #a0283d;
  --el-color-info: #909399;
  --el-color-info-rgb: 144, 147, 153;
  --el-color-info-light-1: #a6a9ad;
  --el-color-info-light-2: #bcbec2;
  --el-color-info-light-3: #d2d3d6;
  --el-color-info-light-4: #dfe0e2;
  --el-color-info-light-5: #e8e9eb;
  --el-color-info-light-6: #eff0f1;
  --el-color-info-light-7: #f4f5f6;
  --el-color-info-light-8: #f9f9fa;
  --el-color-info-light-9: #fcfcfd;
  --el-color-info-dark-2: #5c5e63;
}
`
document.head.appendChild(themeOverrides)
